<template>
  <div class="tables-merge-wrapper">
    <table>
      <tr>
        <th>{{ $t('config.profile.mergeTable.col1') }}</th>
        <th>{{ $t('config.profile.mergeTable.col2') }}</th>
        <th v-for="(item, index) in selectedList" :key="index">
          {{ `${$t('config.profile.mergeTable.coln')} ${item.id}` }}
        </th>
      </tr>
      <tr>
        <td />
        <td />
        <td v-for="n in selectedList.length" :key="n" class="clickable">
          <button
            type="button"
            class="btn mini primary"
            @click="onClickChooseAll($event, n - 1)"
          >
            {{ $t('config.profile.mergeTable.chooseAll') }}
          </button>
        </td>
      </tr>
      <tr v-for="(item, index) in list" :key="index">
        <template v-for="[key, data] in item">
          <td
            v-if="key !== 'selectedField'"
            :key="key"
            :class="{ selected: key === item.get('selectedField') }"
            @click="onClickCell($event, item, index, key, data)"
          >
            {{ data?.text ? data.text : data }}
          </td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
import {
  convertToVerticalList,
  convertToHorizontalObj
} from '@/utils/dataHandler'
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    selectedList: {
      type: Array,
      default: () => []
    },
    headerList: {
      type: Array,
      default: () => []
    },
    resultTemplate: {
      type: Object,
      default: () => ({})
    },
    idHeader: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      list: null // list of maps
    }
  },
  watch: {
    selectedList(nv, ov) {
      this.list = []
      this.list = convertToVerticalList(
        this.selectedList,
        this.headerList,
        this.idHeader
      )
    }
  },
  mounted() {
    this.list = []
    this.list = convertToVerticalList(
      this.selectedList,
      this.headerList,
      this.idHeader
    )
  },
  methods: {
    onClickCell(event, fieldRowData, rowIndex, colField, value) {
      // console.log(event, fieldRowData, rowIndex, colField, value)
      if (colField === 'result' || colField === 'field') {
        return
      }

      const map = fieldRowData
      map.set('result', value)
      map.set('selectedField', colField)
      this.$set(this.list, rowIndex, new Map(map))
      this.$emit(
        'input',
        convertToHorizontalObj(this.list, this.resultTemplate)
      )
    },
    onClickChooseAll(event, index) {
      const value = this.selectedList[index]
      this.list.forEach((item, index) => {
        // item.set('result', value[item.get('field').value])
        const map = this.list[index]
        map.set('result', value[item.get('field').value])
        map.set('selectedField', value[this.idHeader])
        this.$set(this.list, index, new Map(map))
      })
      this.$emit(
        'input',
        convertToHorizontalObj(this.list, this.resultTemplate)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.tables-merge-wrapper {
  display: flex;
}

td.selected {
  background: #e7f6e5 !important;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

th {
  background-color: #357456;
  color: white;
  height: 40px;
}
td.clickable {
  text-align: center;
}

// tr:nth-child(even) {
//   background-color: #dddddd;
// }
</style>
